/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { Flex } from "rebass"

const Button = ({
  children,
  onClick,
  to,
  href,
  variant,
  disabled,
  ...otherProps
}) => {
  let Tag = "button"

  if (href) {
    Tag = "a"
  }

  if (to) {
    Tag = Link
  }

  return (
    <Tag
      onClick={onClick}
      to={to}
      href={href}
      sx={{
        display: "inline-block",
        appearance: "none",
        border: "none",
        boxShadow: "none",
        color: "currentColor",
        cursor: "pointer",
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
        variant: `buttons.${variant}`,
      }}
      {...otherProps}
    >
      <Flex as="span" sx={{ alignItems: "center", justifyContent: "center" }}>
        {children}
      </Flex>
    </Tag>
  )
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
  variant: PropTypes.string,
}

Button.defaultProps = {
  onClick: null,
  to: null,
  variant: "primary",
}

export default Button
